export const getTimeChartOptions = ({ colors }) => ({
  chart: {
    type: 'area',
    stacked: false,
    height: 380,
    toolbar: { show: false },
    zoom: { enabled: false },
  },
  dataLabels: { enabled: false },
  colors,
  markers: { size: 0 },
  stroke: { width: 2, curve: 'smooth' },
  fill: {
    gradient: {
      shadeIntensity: 1,
      inverseColors: false,
      opacityFrom: 0.45,
      opacityTo: 0.25,
      stops: [10, 100, 100, 100],
    },
  },
  yaxis: {
    labels: {
      style: { colors },
      offsetX: 0,
      formatter(val) {
        return val;
      },
    },
    axisBorder: { show: false },
    axisTicks: { show: false },
  },

  xaxis: {
    type: 'category',
    labels: {
      formatter(value) {
        if (!value) return '';

        const [h, m] = String(value).split(':');
        const hour = Number(h);

        if (Number.isNaN(hour)) return '';
        if (m !== '00') return '';
        if (hour % 2 !== 0) return '';

        const paddedHour = String(hour).padStart(2, '0');
        return `${paddedHour}:00`;
      },
    },
    tooltip: {
      enabled: false,
    },
  },
  tooltip: {
    enabled: true,
    shared: true,
    intersect: false,
    x: {
      show: false,
    },
  },
  legend: {
    position: 'bottom',
    horizontalAlign: 'center',
    offsetY: 10,
  },
  grid: {
    row: {
      colors: ['transparent', 'transparent'],
      opacity: 0.2,
    },
    borderColor: 'blue',
  },
});
